import { TableAttachment } from '../../types/attachment';
import {
  scheduledSendExportFormats,
  scheduledSendGeospatialFormats,
  supportsGeoExport
} from 'common/downloadLinks';
import { I18n } from 'common/visualizations';
import { REPORT_ATTACHMENT_ICON, TABLE_ATTACHMENT_ICON } from '../../constants';
import { isStory } from 'common/views/view_types';
import { View } from 'common/types/view';
import { isEmpty, isUndefined } from 'lodash';

const scope = 'shared.components.schedule_send_report.modal.attachment_section';

export const getTableOptions = (tableList: TableAttachment[] | void) => {
  const tableAttachmentsList =
    tableList?.map((table: TableAttachment) => {
      return {
        label: table.title,
        value: table.identifier,
        leadingIcon: TABLE_ATTACHMENT_ICON,
        leadingIconType: 'component',
        tooltip: { text: table.title }
      };
    }) ?? [];

  const fullReport = {
    label: I18n.t('full_report', { scope }),
    value: 'full-report',
    leadingIcon: REPORT_ATTACHMENT_ICON,
    leadingIconType: 'component',
    tooltip: { text: I18n.t('full_report', { scope }) }
  };

  return [fullReport, ...tableAttachmentsList];
};

export const getExportFormatOptions = (tableList: TableAttachment[] | void, tableCurrentValue: string) => {
  const currTable = tableList?.find((table) => table.identifier === tableCurrentValue);
  const validExportFormats = currTable?.withGeoSpatialData
    ? scheduledSendExportFormats.concat(scheduledSendGeospatialFormats)
    : scheduledSendExportFormats;

  return validExportFormats.map((exportFormat) => {
    return {
      label: I18n.t(`shared.explore_grid.export_dataset_modal.${exportFormat}`),
      value: exportFormat
    };
  });
};

export const tablesFromStoryData = (view: View) => {
  if (isStory(view) && !isUndefined(window.STORY_DATA)) {
    let tableCount = 0;

    return window.STORY_DATA.blocks
      .map((block: any) => {
        const component = block.components[0];
        if (component.type === 'socrata.visualization.agTable') {
          tableCount = tableCount + 1;
          const title = isEmpty(component.value.vif.title)
            ? `Table ${tableCount}`
            : component.value.vif.title;
          const identifier = `table-number-${tableCount}`;
          const dimension = component.value.vif.series[0].dataSource.dimension as View;
          const withGeoSpatialData = supportsGeoExport(dimension);
          return {
            identifier: identifier,
            title: title,
            withGeoSpatialData: withGeoSpatialData
          };
        }
      })
      .filter((tableObj: TableAttachment) => tableObj !== undefined) as TableAttachment[];
  }
};
